(function () {
  'use strict';

  function paxAjaxAdd(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var submitBtn = form.querySelector('button[type="submit"], .pax-cta');
    if (submitBtn) {
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.dataset.label = submitBtn.textContent;
      submitBtn.textContent = '…';
      submitBtn.disabled = true;
    }
    var drawer = document.querySelector('cart-drawer');
    var formData = new FormData(form);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        formData.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        formData.append('sections_url', window.location.pathname);
      } catch (err) { /* ignore */ }
    }
    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          if (submitBtn) {
            submitBtn.removeAttribute('aria-busy');
            submitBtn.textContent = submitBtn.dataset.label || 'Jetzt kaufen';
            submitBtn.disabled = false;
          }
          alert(response.description || 'Fehler beim Hinzufügen zum Warenkorb.');
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          if (drawer.classList && drawer.classList.contains('is-empty')) {
            drawer.classList.remove('is-empty');
          }
          drawer.renderContents(response);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error(err);
        window.location.href = '/cart';
      })
      .finally(function () {
        if (submitBtn) {
          setTimeout(function () {
            submitBtn.removeAttribute('aria-busy');
            submitBtn.textContent = submitBtn.dataset.label || 'Jetzt kaufen';
            submitBtn.disabled = false;
          }, 800);
        }
      });
  }

  function init(scope) {
    var root = scope || document;

    /* ===================== TABS ===================== */
    root.querySelectorAll('[data-pax-tabs]').forEach(function (tabsEl) {
      if (tabsEl.dataset.paxBound) return;
      tabsEl.dataset.paxBound = '1';
      var buttons = tabsEl.querySelectorAll('.pax-tab');
      var panels = tabsEl.querySelectorAll('.pax-tabs__panel');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-tab');
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var panel = tabsEl.querySelector('[data-tab-panel="' + target + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });

    /* ===================== VARIANTS (visual) ===================== */
    root.querySelectorAll('[data-pax-variants]').forEach(function (group) {
      if (group.dataset.paxBound) return;
      group.dataset.paxBound = '1';
      var labelEl = document.querySelector('[data-pax-variant-label]');
      var hidden = group.querySelector('[data-pax-variant-hidden]');
      var gallery = document.querySelector('[data-pax-gallery]');
      group.querySelectorAll('.pax-variant').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          group.querySelectorAll('.pax-variant').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var value = btn.getAttribute('data-value') || btn.textContent.trim();
          if (labelEl) labelEl.textContent = value;
          var vid = btn.getAttribute('data-variant-id');
          if (hidden && vid) hidden.value = vid;

          var imgId = btn.getAttribute('data-variant-image-id');
          if (imgId && gallery) {
            var mainImg = gallery.querySelector('.pax-gallery__main-img[data-image-id="' + imgId + '"]');
            var thumb = gallery.querySelector('.pax-gallery__thumb[data-image-id="' + imgId + '"]');
            if (mainImg) {
              gallery.querySelectorAll('.pax-gallery__main-img').forEach(function (i) { i.classList.remove('is-active'); });
              mainImg.classList.add('is-active');
            }
            if (thumb) {
              gallery.querySelectorAll('.pax-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
              thumb.classList.add('is-active');
            }
          }
        });
      });
    });

    /* ===================== GALLERY THUMBS ===================== */
    root.querySelectorAll('[data-pax-gallery]').forEach(function (gallery) {
      if (gallery.dataset.paxBound) return;
      gallery.dataset.paxBound = '1';
      var thumbs = gallery.querySelectorAll('.pax-gallery__thumb');
      var mainImages = gallery.querySelectorAll('.pax-gallery__main-img');
      thumbs.forEach(function (thumb, idx) {
        thumb.addEventListener('click', function (e) {
          e.preventDefault();
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImages.length) {
            mainImages.forEach(function (img) { img.classList.remove('is-active'); });
            if (mainImages[idx]) mainImages[idx].classList.add('is-active');
          }
        });
      });
    });

    /* ===================== QUANTITY INPUTS ===================== */
    root.querySelectorAll('[data-pax-qty]').forEach(function (qty) {
      if (qty.dataset.paxBound) return;
      qty.dataset.paxBound = '1';
      var input = qty.querySelector('input');
      var dec = qty.querySelector('[data-pax-qty-dec]');
      var inc = qty.querySelector('[data-pax-qty-inc]');
      if (dec) dec.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        input.value = Math.max(1, v - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (inc) inc.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ===================== REVIEWS TAB SWITCH (visual) ===================== */
    root.querySelectorAll('[data-pax-review-tabs]').forEach(function (tabs) {
      if (tabs.dataset.paxBound) return;
      tabs.dataset.paxBound = '1';
      var btns = tabs.querySelectorAll('.pax-reviews__tab');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
        });
      });
    });

    /* ===================== AJAX ADD-TO-CART → DRAWER ===================== */
    root.querySelectorAll('[data-pax-product-form]').forEach(function (form) {
      if (form.dataset.paxBound) return;
      form.dataset.paxBound = '1';
      form.addEventListener('submit', paxAjaxAdd);
    });
    root.querySelectorAll('[data-pax-sticky] form').forEach(function (form) {
      if (form.dataset.paxBound) return;
      form.dataset.paxBound = '1';
      form.addEventListener('submit', paxAjaxAdd);
    });
    root.querySelectorAll('.pax-upsell__form').forEach(function (form) {
      if (form.dataset.paxBound) return;
      form.dataset.paxBound = '1';
      form.addEventListener('submit', paxAjaxAdd);
    });

    /* ===================== REVIEWS LOAD-MORE ===================== */
    root.querySelectorAll('[data-pax-reviews-loadmore]').forEach(function (btn) {
      if (btn.dataset.paxBound) return;
      btn.dataset.paxBound = '1';
      var list = btn.closest('.pax-reviews').querySelector('[data-pax-reviews-list]');
      if (!list) return;
      var step = parseInt(list.getAttribute('data-step') || '8', 10);
      var total = parseInt(btn.getAttribute('data-total') || '0', 10);
      btn.addEventListener('click', function () {
        var hidden = list.querySelectorAll('[data-pax-review-index][hidden]');
        var reveal = Math.min(step, hidden.length);
        for (var i = 0; i < reveal; i++) hidden[i].removeAttribute('hidden');
        var stillHidden = list.querySelectorAll('[data-pax-review-index][hidden]');
        if (stillHidden.length === 0) {
          btn.style.display = 'none';
        } else {
          var visible = total - stillHidden.length;
          var label = btn.querySelector('[data-pax-loadmore-label]');
          if (label) {
            var base = label.dataset.baseLabel || label.textContent;
            label.dataset.baseLabel = base;
            label.textContent = base + ' (' + visible + '/' + total + ')';
          }
        }
      });
    });
  }

  /* ===================== STICKY BUY BAR ===================== */
  function bindSticky() {
    var bar = document.querySelector('[data-pax-sticky]');
    if (!bar || bar.dataset.paxBound) return;
    var trigger = document.querySelector('[data-pax-sticky-trigger]');
    if (!trigger) return;
    bar.dataset.paxBound = '1';
    var onScroll = function () {
      var rect = trigger.getBoundingClientRect();
      if (rect.bottom < 0) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function start() {
    init(document);
    bindSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-init when Shopify theme editor re-renders sections
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    bindSticky();
  });
})();
